export const AppRoutes = {
  HOME: "/",
  ITEMS: "/items",
  ITEM: "/item/:id",
  CONTACTS: "/contacts",
  ORDERS: "/orders",
  BLOG: "/blog",
  POSTS:"/blog/posts",
  POST: "/blog/posts/:id",
  ADDPOST: "/blog/add"
};
